import {connect} from 'react-redux';
import App from './App';

const mapStateToProps = ({
                             locales: {current: currentLocale}
                         }) => {
    return {
      currentLocale
    };
};

export default connect(
    mapStateToProps,
    null
)(App);
